import React from 'react';
import MoneySalePriceRowProperties from './MoneySalePriceRowProperties';
import ViewSmall from '../../../../../ui_components/MediaView/ViewSmall';
import MoneySalePriceRowMedium from './MoneySalePriceRowMedium';
import ViewMedium from '../../../../../ui_components/MediaView/ViewMedium';
import ViewLarge from '../../../../../ui_components/MediaView/ViewLarge';


const MoneySalePriceRow: React.FC<MoneySalePriceRowProperties> = ({
                                                    salePrice,
                                                    moneySalePrice,
                                                    onUpdate
                                                }) => {
    return (
        <>
            <ViewSmall>
                <MoneySalePriceRowMedium onUpdate={onUpdate} salePrice={salePrice} moneySalePrice={moneySalePrice}/>
            </ViewSmall>
            <ViewMedium>
                <MoneySalePriceRowMedium onUpdate={onUpdate} salePrice={salePrice} moneySalePrice={moneySalePrice}/>
            </ViewMedium>
            <ViewLarge>
                <MoneySalePriceRowMedium onUpdate={onUpdate} salePrice={salePrice} moneySalePrice={moneySalePrice}/>
            </ViewLarge>
        </>
    )
}

export default MoneySalePriceRow;
